export const siteInfo = {
  name: '偷拍自拍技巧大全',
  tagline: '拍出自然真实的每一个瞬间',
  description: '偷拍自拍技巧大全是一个专注于自然感自拍摄影的中文内容平台。我们致力于分享最实用的偷拍自拍构图技巧、光线运用方法、设备推荐及后期处理教程，帮助每一位摄影爱好者轻松拍出真实、有故事感的日常瞬间。',
  founded: '2024年',
  email: 'hello@candid-selfie.cn',
  wechat: 'CandidSelfie',
  xiaohongshu: '偷拍自拍技巧大全',
  stats: {
    articles: 128,
    readers: 56000,
    categories: 6,
  },
  faqs: [
    {
      question: '什么是"偷拍自拍"？和普通自拍有什么区别？',
      answer: '偷拍自拍（Candid Selfie）是一种追求自然真实感的自拍风格。与传统的"看镜头、摆姿势、按快门"不同，偷拍自拍强调捕捉真实的瞬间——你在做某件事、看向某个方向、或者沉浸在某种情绪中的状态。画面看起来像是由他人"偷拍"的，但实际上是你自己有意为之的创作。这种风格的核心是"不刻意的美感"。',
    },
    {
      question: '我没有专业相机，只用手机能拍出好看的偷拍自拍吗？',
      answer: '当然可以！实际上，手机是偷拍自拍最方便的工具。现在的智能手机摄像头已经非常强大，完全能满足日常拍摄需求。更重要的是，偷拍自拍讲究的是构图、光线和瞬间的捕捉，而不是设备的参数。我们网站上90%的技巧都可以直接用手机实现。推荐搭配一个便携三脚架和蓝牙遥控器，体验会更好。',
    },
    {
      question: '偷拍自拍一定要用三脚架吗？',
      answer: '不一定要用，但强烈推荐。三脚架能解放你的双手，让你可以摆出更自然的姿势，同时保证画面稳定清晰。如果没有三脚架，也可以利用环境中的平面——桌子、窗台、台阶、书架——把手机靠在上面。创意比设备更重要。',
    },
    {
      question: '如何在人多的地方自然地自拍？',
      answer: '首先要放下"被人看到在自拍很尴尬"的心理。现在的街头和公共场所，拍照已经是再正常不过的事情。如果还是觉得不自在，可以试试这些方法：选择人少的角落、利用手机蓝牙遥控器（看起来像在发消息）、或者找一个朋友一起拍。拍得多了，自然就习惯了。',
    },
    {
      question: '后期修图到什么程度才不算"过度"？',
      answer: '一个简单的判断标准：修完图后放十分钟，再看第一眼。如果第一反应是"这张照片修过"，那就是修过度了。对于偷拍自拍来说，后期处理应该服务于"还原真实氛围"而不是"改变真实"。调整曝光、色温、对比度等基础参数完全OK，但尽量不要大幅改变面部结构或肤色。',
    },
    {
      question: '你们的教程适合完全零基础的摄影新手吗？',
      answer: '非常适合！我们的内容从最基础的概念讲起，用通俗易懂的语言和大量的实际案例，帮助零基础的朋友逐步掌握偷拍自拍的各项技巧。从如何打开手机网格线，到高级的光线运用，每一篇教程都力求让新手也能一看就懂、一学就会。',
    },
  ],
  testimonials: [
    {
      name: '小雨',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20natural%20lighting%2C%20soft%20smile%2C%20clean%20minimal%20background%2C%20professional%20headshot%20style%2C%20lifestyle%20photography%2C%20neutral%20tones&width=200&height=200&seq=avatar-01&orientation=squarish',
      text: '以前每次自拍都觉得很僵硬，看了你们的构图教程后，现在用网格线+三分法，拍出来的照片朋友们都说像换了一个人！',
    },
    {
      name: '阿杰',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20clean%20minimal%20background%2C%20professional%20headshot%20style%2C%20lifestyle%20photography%2C%20neutral%20tones&width=200&height=200&seq=avatar-02&orientation=squarish',
      text: '作为一个男生，以前完全不会自拍。这个网站让我学会了用光线和场景来讲故事，现在旅行照终于不再是"到此一游"了。',
    },
    {
      name: '小鹿',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20natural%20lighting%2C%20gentle%20smile%2C%20clean%20minimal%20background%2C%20professional%20headshot%20style%2C%20lifestyle%20photography%2C%20neutral%20tones&width=200&height=200&seq=avatar-03&orientation=squarish',
      text: '咖啡馆自拍那篇简直是我的救星！现在每次去咖啡馆都知道坐哪里、怎么用杯子当道具，照片氛围感拉满。',
    },
  ],
};